import type { ExportSettingsSourceType } from "app/pages/sales-intelligence/sub-modules/management/store/type";
import { ExportSettingsSourceType as SourceType } from "app/pages/sales-intelligence/sub-modules/management/store/type";

import type { EnrichmentJobMappingDTO } from "../types/types";

export const isTechnologiesField = (sourceType?: ExportSettingsSourceType): boolean =>
    sourceType === SourceType.Technologies;

export const isPredefinedField = (sourceType?: ExportSettingsSourceType): boolean =>
    sourceType === SourceType.Predefined;

const isMappingPopulated = (mapping: EnrichmentJobMappingDTO): boolean => {
    if (!mapping.externalField) {
        return false;
    }

    if (isTechnologiesField(mapping.sourceType) && !mapping.metadata) {
        return false;
    }

    if (isPredefinedField(mapping.sourceType) && !mapping.metadata) {
        return false;
    }

    return true;
};

export const areMappingsValid = (mappings: readonly EnrichmentJobMappingDTO[]): boolean =>
    mappings.every(isMappingPopulated);

const areMappingsEqual = (a: EnrichmentJobMappingDTO, b: EnrichmentJobMappingDTO): boolean =>
    a.externalField === b.externalField &&
    a.overwrite === b.overwrite &&
    a.sourceType === b.sourceType &&
    a.metadata === b.metadata;

export const areMappingsUnchanged = (
    current: readonly EnrichmentJobMappingDTO[],
    initial: readonly EnrichmentJobMappingDTO[],
): boolean => current.length === initial.length && current.every((m, i) => areMappingsEqual(m, initial[i]));

export const hasIndustryEnrichmentMapping = (mappings: readonly EnrichmentJobMappingDTO[]): boolean =>
    mappings.some((mapping) => mapping.metadata === "industry");
